import { type IArtworkMinimum } from '@metmuseum/types';
import styles from './object-info-table.module.scss';
import LegacyOrMarkdownParser from 'components/rich-text/legacy-or-markdown-parser';
import { useTranslations } from 'next-intl';
//The data from the collection API is ugly and full of html (<br>s and <i> tags mostly).

//Title, artist, and date are deliberately absent: the object modal already shows them
//in the tombstone above the web label, so repeating them here is redundant (DIGAPPDEV-4810).
//TODO - add classification + provenance data.
const ObjectInfoTable = ({ object }: Props) => {
	const t = useTranslations('collection.fieldNames');
	const {
		period,
		culture,
		medium,
		dimensions,
		// classification,
		creditLine,
		accessionNumber,
		rightsAndReproduction,
		// provenance
	} = object;
	return (
		<div className={styles.grid}>
			{period && (
				<>
					<div className={styles.label}>{t('period')}</div>{' '}
					<LegacyOrMarkdownParser>{period}</LegacyOrMarkdownParser>
				</>
			)}
			{culture && (
				<>
					<div className={styles.label}>{t('culture')}</div>{' '}
					<LegacyOrMarkdownParser>{culture}</LegacyOrMarkdownParser>
				</>
			)}
			{medium && (
				<>
					<div className={styles.label}>{t('medium')}</div>{' '}
					<LegacyOrMarkdownParser>{medium}</LegacyOrMarkdownParser>
				</>
			)}
			{dimensions && (
				<>
					<div className={styles.label}>{t('dimensions')}</div>{' '}
					<LegacyOrMarkdownParser>{dimensions}</LegacyOrMarkdownParser>
				</>
			)}
			{/* {classification && <><div className={styles.label}>Classification</div> <LegacyOrMarkdownParser>{classification}</LegacyOrMarkdownParser></>} */}
			{creditLine && (
				<>
					<div className={styles.label}>{t('creditLine')}</div>{' '}
					<LegacyOrMarkdownParser>{creditLine}</LegacyOrMarkdownParser>
				</>
			)}
			{accessionNumber && (
				<>
					<div className={styles.label}>{t('accessionNumber')}</div>{' '}
					<LegacyOrMarkdownParser>{accessionNumber}</LegacyOrMarkdownParser>
				</>
			)}
			{rightsAndReproduction && (
				<>
					<div className={styles.label}>{t('rightsAndReproduction')}</div>{' '}
					<LegacyOrMarkdownParser>
						{rightsAndReproduction}
					</LegacyOrMarkdownParser>
				</>
			)}
			{/* {provenance && <><div className={styles.label}>Provenance</div> <LegacyOrMarkdownParser>{provenance}</LegacyOrMarkdownParser></>} */}
		</div>
	);
};

export default ObjectInfoTable;

interface Props {
	object: IArtworkMinimum;
}
